import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { get_attendance_data } from "../../../services/employeeApi";
import { formatDate } from "../../../utils/date_utils";
import { Form } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../../components/UiComponent/customTable";
import { GetUserInfo, hasAccess } from "../../../utils/permissionChecker";
const AttendanceList = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);
  const branch_id = user?.employee?.branch_id;
  const AttendanceQuery = useQuery(
    ["daily_attendance_list", branch_id, selectedDate],
    () => get_attendance_data(branch_id, selectedDate),
    {
      keepPreviousData: true,
      enabled: !!branch_id,
    }
  );

  const attendanceData = useMemo(() => {
    return AttendanceQuery.data || [];
  }, [AttendanceQuery.data]);

  if (!branch_id) {
    return <div>No branch assigned to your profile. Contact admin.</div>;
  }

  if (AttendanceQuery.isError) {
    return <div>Error: {AttendanceQuery.error.message}</div>;
  }
  const attendanceColumns = [
    {
      header: "full_name",
      accessor: "first_name",
      accessorFn: (row) =>
        `${row.employee.first_name} ${row.employee.father_name} `,
    },
    {
      header: "status",
      accessorFn: (row) =>
        row.status
          ? row.status.charAt(0).toUpperCase() +
            row.status.slice(1).toLowerCase()
          : "",
    },
    {
      header: "date",
      accessorFn: (row) => `${formatDate(row.date)}`,
    },
  ];

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };
  return (
    <div>
      <BasicTable
        data={Array.isArray(attendanceData?.data) ? attendanceData.data : []}
        columns={attendanceColumns}
        title={`attendance_list`}
        actionButton={
          <div>
            <Form.Control
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              max={today}
              style={{ width: "250px" }}
              required
            />
          </div>
        }
      />
    </div>
  );
};
export default AttendanceList;
